/*** IMPORTS FROM imports-loader ***/
var define = false;

var conf = require('./conf');
// var util = require('./util')

var callNativeFunction; // 调用本地接口
var checkNativeFunction; // 检查本地接口是否存在
var attachNativeEvent; // 监听本地事件
var detachNativeEvent; // 注销本地事件

var isThunder = false;

if (window.native && window.native.CallNativeFunction) { // Chrome内核
  callNativeFunction = window.native.CallNativeFunction;
  checkNativeFunction = window.native.CheckNativeFunction;
  attachNativeEvent = window.native.AttachNativeEvent;
  detachNativeEvent = window.native.DetachNativeEvent;
}
// else if ('CallNativeFunction' in window.external) { // IE内核
//   callNativeFunction = function () {
//     util.apply('window.external.CallNativeFunction', arguments);
//   };

//   checkNativeFunction = function () {
//     util.apply('window.external.CheckNativeFunction', arguments);
//   };

//   attachNativeEvent = function () {
//     util.apply('window.external.AttachNativeEvent', arguments);
//   };

//   detachNativeEvent = function () {
//     util.apply('window.external.DetachNativeEvent', arguments);
//   };
// }
else if (window.external && window.external.GetUserID) { // IE内核同步API
  callNativeFunction = function () {
    var args = Array.prototype.slice.call(arguments); // 参数列表
    var name = args.shift(); // 方法名
    var callback = args.pop(); // 回调函数
    var cmd = 'window.external.' + name + '('; // 执行语句
    var params = [];
    var val; // 返回值

    // 拼接执行的API语句
    if (args.length > 0) {
      for (var i = 0; i < args.length; i++) {
        params.push('args[' + i + ']');
      }
      cmd += params.join(',');
    }
    cmd += ')';

    try {
      val = eval(cmd);
      callback(conf.NFERRORCODE_SUCCESS, val);
    } catch (e) {
      callback(conf.NFERRORCODE_FUNCTIONNOTEXIST);
    }
  }

  checkNativeFunction = function () {
    var args = Array.prototype.slice.call(arguments); // 参数列表
    var name = args.shift(); // 方法名
    var callback = args.pop(); // 回调函数
    if (window.external[name]) {
      callback(conf.NFERRORCODE_SUCCESS);
    } else {
      callback(conf.NFERRORCODE_FUNCTIONNOTEXIST);
    }
  };

  attachNativeEvent = function () {
    return window.external.AttachEvent(arguments[0], arguments[1]);
  };

  detachNativeEvent = function () {
    return window.external.DetachEvent(arguments[0], arguments[1]);
  };
} else { // 非迅雷9环境
  callNativeFunction = function () {
    var args = Array.prototype.slice.call(arguments);
    var callback = args.pop();
    callback(conf.NFERRORCODE_NOTINXL9);
  };

  checkNativeFunction = attachNativeEvent = detachNativeEvent = function () { };
}

var native = {
  callNativeFunction: function () {
    var args = Array.prototype.slice.call(arguments);
    var callback = args.pop();
    callNativeFunction.apply(null, args.concat(function (err, val) {
      switch (err) {
        case conf.NFERRORCODE_SUCCESS:
          typeof callback === 'function' && callback(null, val);
          break;
        case conf.NFERRORCODE_FUNCTIONNOTEXIST:
          typeof callback === 'function' && callback('function not exist');
          break;
        case conf.NFERRORCODE_PARAMETERERROR:
          typeof callback === 'function' && callback('parameter error');
          break;
        case conf.NFERRORCODE_NOTINXL9:
          typeof callback === 'function' && callback('not in xl9');
          break;
      }
    }));
  },

  checkNativeFunction: checkNativeFunction,

  attachNativeEvent: attachNativeEvent,

  detachNativeEvent: detachNativeEvent,

  isThunder: function () {
    return isThunder;
  }
};

// 判断是否在迅雷客户端中
native.callNativeFunction('GetThunderVersion', function (err) {
  if (!err) {
    isThunder = true;
  }
});

module.exports = native




//////////////////
// WEBPACK FOOTER
// ./native.js
// module id = 2
// module chunks = 0